export default __webpack_public_path__ + "static/media/notifyEmpty.e71e6ce4.svg";